<template>
  <div class="login_body">

    <section>

      <div class="login_middle_form">

        <router-link to="/" class="login_middle_logo">
          <img src="../../assets/logo_white.png" />
        </router-link>

        <div class="tips">礼达独家探针库查询</div>

        <form :model="loginForm" :rules="rules">
          <ul>
            <li>
              <input type="text" placeholder="账户" name="login_name" v-model="loginForm.name" style="width:100%;">
            </li>
            <li>
              <input type="password" placeholder="密码" name="login_pass" v-model="loginForm.password" style="width:100%;">
            </li>
          </ul>
          <div class="login_misc_wrapper">
            <!--<label class="remember_me">
              <input type="checkbox" value="true" name="remember_me">记住我
            </label>
            <a href="javascript:void(0)">忘记密码</a>-->
          </div>
          <a href="javascript:void(0)" class="login_btn" @click="confirm">登 录</a>
          <div class="login_misc_wrapper">
            <a href="javascript:void(0)"></a>
            <a href="javascript:void(0)" @click="applyOpen">注册账户</a>
          </div>
        </form>
      </div>

    </section>

    <div class="pop_bg" v-show="popBgShow" @click="applyClose()"></div>
    <div class="pop_apply_box" v-show="popShow">
      <div class="header_info">
        <div class="title">礼达探针库访问申请（如需开通权限，请联系客服）</div>
        <a href="javascript:void(0)" class="close_btn" @click="applyClose()">×</a>
      </div>
      <form :model="registerForm" :rules="registerrules">
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">姓名：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="姓名" name="register_name" v-model="registerForm.name" />
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">电话：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="电话" name="register_tel" v-model="registerForm.tel" />
          </dd>
        </dl>
        <div class="footer_btn">
          <input type="button" id="ORDERPOST" value="立即申请" @click="registerconfirm">
        </div>
      </form>
    </div>
    <LoginFooter></LoginFooter>
  </div>
</template>

<script>
import LoginFooter from '../footer/login_footer.vue';
import api from './../../axios/api.js';
import md5 from './../../assets/js/md5.min.js'


export default {
  components: {
    LoginFooter
  },
  data() {
    return {
      fromtype:1,
      loginForm: {
        name: '',
        password: '',
      },
      registerForm: {
        name: "",
        tel: "",
        idcard: ""
      },
      popBgShow: false,
      popShow: false,

      rules: {
        name: [{ required: true, message: "请输入账号", trigger: "blur" }],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      registerrules: {
        name: [{ required: true, message: "请输入账号", trigger: "blur" }],
        tel: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        idcard: [{ required: true, message: "请输入身份", trigger: "blur" }]
      },
    }
  },
  mounted() {
  },
  created() {
    this.fromtype=this.$route.query.id?this.$route.query.id:1;
  },
  methods: {
    applyOpen() {
      this.popBgShow = true;
      this.popShow = true;
    },
    applyClose() {
      this.popBgShow = false;
      this.popShow = false;
    },
    confirm() {
      let that = this;
      const userName = this.loginForm.name;
      const password = this.loginForm.password;
      if (!userName) {
        this.showMessage("账号不能为空！");
      } else if (!password) {
        this.showMessage("密码不能为空！");
      } else {
        let urllist = '/user/login';
        api.getTableData(urllist, { isLogined: false, needLogin: false, password: password, username: userName }).then(res => {
          if (res.result == 1) {
            window["authtoken"] = res.data.ticket;
            localStorage.setItem("authtoken", res.data.ticket);
            localStorage.setItem("isLogined", true);
            localStorage.setItem("needLogin", false);
            localStorage.setItem("username", userName);
            if(that.fromtype==1){
              location.href = "/";
            }else{
              location.href = "/show";
            } 
          }
        });
        //this.$router.replace('/');
      }
    },
    registerconfirm() {
      let that = this;
      const regName = this.registerForm.name;
      const tel = this.registerForm.tel;
      const idcard = 2;
      if (!regName) {
        this.showMessage("姓名不能为空！");
        return;
      } else if (!tel) {
        this.showMessage("电话不能为空！");
        return;
      } else if (!idcard) {
        this.showMessage("身份不能为空！");
        return;
      } else {
        let urllist = '/action/users/regester';
        let param = {
          username: regName,
          phone: tel,
          type: idcard,
          nickname: regName,
          sex: 3,
          realname: regName,
          birthday: null
        };
        api.getTableData(urllist, JSON.stringify(param)).then(res => {
          if (res.result == 1) {
            if (res.data) {
              //location.href = "/";
              alert("注册成功，默认密码123456");
              that.applyClose();

            } else {
              alert("用户已存在！");
            }
          }
        });
      }
    },
    showMessage(val) {
      toastr.error(val, "错误", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true
      });
    }
  }
}
</script>


<style scoped>
section {
  padding-top: 0;
  margin: auto;
}

.form-select {
  width: 100%;
  border: 1px solid #d6d6d6;
  border-radius: 5px;
  padding: 0 10px;
  font-size: 14px;
  color: #333;
  height: 45px;
  line-height: 45px;
  -webkit-transition: all 0.2s linear 0s;
  transition: all 0.2s linear 0s;
}

.formcolumn-item-ct input {
  width:100%;
}

</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue